import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import BarChartIcon from '@mui/icons-material/BarChart'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { PieChart } from '@mui/x-charts/PieChart'
import { Tooltip } from '@mui/material'
import { always, compose } from 'ramda'

import axios, { pluckData } from 'src/utilities/http-client'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import noop from 'src/utilities/noop'
import { downloadFile } from 'src/v3/utilities/filesystem'
import {
  dashboardChartExpandedChanged,
  fetchAccessLevelUsersCountChart,
  selectAccessLevelUsersCountChart,
  selectDashboardChartExpanded,
  selectAccessLevelUsersStatus,
} from '../../admin.slice'

let exportAccessLevelUsers = () =>
  axios.get('/api/v2/admin/access-level/users/export').then(pluckData)

export default () => {
  let accessUsersChart = useAppSelector(selectAccessLevelUsersCountChart)
  let accessUsersChartStatus = useAppSelector(selectAccessLevelUsersStatus)
  let expandedChart = useAppSelector(selectDashboardChartExpanded)
  let dispatch = useAppDispatch()

  useEffect(() => {
    if (accessUsersChartStatus === 'uninitialized') {
      dispatch(fetchAccessLevelUsersCountChart())
    }
  }, [accessUsersChartStatus])

  return (
    <Card>
      <CardContent>
        <div className="pb-2 ">
          <PieChart
            series={[
              {
                data: accessUsersChart,
              },
            ]}
            height={expandedChart === 'AccessLevelUsers' ? 500 : 200}
          />
        </div>
        <Typography gutterBottom variant="h5" component="div">
          Access Level
        </Typography>
        <Typography gutterBottom variant="h6" component="div">
          Users
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Amount of users per access level, such as Bound Tree limited or full
          access.
        </Typography>
      </CardContent>
      <CardActions>
        <Tooltip title="View Chart">
          <IconButton
            size="small"
            onClick={
              compose(
                dispatch,
                dashboardChartExpandedChanged,
                always(
                  expandedChart === 'AccessLevelUsers'
                    ? 'None'
                    : 'AccessLevelUsers',
                ) as any,
              ) as any
            }
          >
            <BarChartIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Export">
          <IconButton
            size="small"
            onClick={() =>
              exportAccessLevelUsers()
                .then((response) => downloadFile(response, 'user_list.csv'))
                .catch(noop)
            }
          >
            <FileDownloadIcon />
          </IconButton>
        </Tooltip>
      </CardActions>
    </Card>
  )
}
